import { useEffect } from "react";

import { env } from "~/env";
import { VISIT_TYPES, VisitType } from "~/services/scheduling";
import { useBookingFlowStore } from "~/stores";
import { useStartBookingFlowMutation } from "../actions";

interface UseStartBookingFlowOptions {
  visitType: VisitType;
  enabled?: boolean;
  onSuccess?: (bookingFlowId: string) => void;
  linkType?: string;
}

export const useStartBookingFlow = ({
  visitType,
  enabled = true,
  onSuccess,
  linkType,
}: UseStartBookingFlowOptions) => {
  const {
    start: startFlow,
    flowInProgress,
    setIsProviderView,
  } = useBookingFlowStore();
  const { mutate: startBookingFlow } = useStartBookingFlowMutation({
    onSuccess: (data) => {
      onSuccess?.(data.id);
      startFlow({
        id: data.id,
        appointmentType: visitType,
      });
    },
  });

  const showProvidersViewABTesting = () => {
    if (visitType !== VISIT_TYPES.INITIAL) {
      return true;
    }
    const percentage = Number(env.VITE_AB_TEST_PROVIDER_VIEW_PERCENTAGE);
    const random = Math.random();
    return random < percentage;
  };

  useEffect(() => {
    if (enabled) {
      const showProvidersView = showProvidersViewABTesting();
      setIsProviderView(showProvidersView);
      startBookingFlow({
        appointmentType: visitType,
        ...(linkType ? { linkType } : {}),
      });
    }
  }, [enabled, flowInProgress, startBookingFlow, visitType]);
};
